import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomErrorToaster from "../components/ErrorToaster/CustomErrorToaster";
import CustomSuccessToaster from "../components/SuccessToaster/CustomSuccessToaster";

export const NotifyError = (message) =>
  toast.error(<CustomErrorToaster errorMessage={message} />,{autoClose: 5000,});
